"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/typeof.js"));
var _default2 = exports.default = {
  props: {
    /* 对话框的打开开关 */
    open: {
      type: Boolean,
      default: false
    },
    /* 设置左侧树图，对象参数参考 https://element.eleme.cn/2.13/#/zh-CN/component/dialog#attributes */
    dialogOptions: {
      type: [Boolean, Object],
      default: false,
      validator: function validator(v) {
        if (typeof v === 'boolean') {
          return Boolean;
        } else if ((0, _typeof2.default)(v) === 'object' && !Array.isArray(v)) {
          return Object;
        } else {
          // eslint-disable-next-line no-console
          console.error('props传入参数错误!!\n', "':dialogOptions=\"<object>\"'\u53C2\u6570\u503C\u5FC5\u987B\u4E3A\u5BF9\u8C61");
        }
        return Boolean;
      }
    },
    /* 设置左侧树图，对象参数参考 https://element.eleme.cn/2.13/#/zh-CN/component/form#attributes */
    formOptions: {
      type: [Boolean, Object],
      default: false,
      validator: function validator(v) {
        if (typeof v === 'boolean') {
          return Boolean;
        } else if ((0, _typeof2.default)(v) === 'object' && !Array.isArray(v)) {
          return Object;
        } else {
          // eslint-disable-next-line no-console
          console.error('props传入参数错误!!\n', "':formOptions=\"<object>\"'\u53C2\u6570\u503C\u5FC5\u987B\u4E3A\u5BF9\u8C61");
        }
        return Boolean;
      }
    },
    /* 表单对象 */
    model: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* 表单校验对象 */
    rules: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* 表单禁用 */
    disabled: {
      type: Boolean,
      default: false
    },
    /* 表单等待状态 */
    loading: {
      type: Boolean,
      default: false
    },
    /* 栅格 */
    grid: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* 对话框底部确定按钮参数设置 */
    okBtn: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* 对话框底部取消按钮参数设置 */
    closeBtn: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* 数据源URL */
    url: {
      type: String,
      default: ''
    },
    /* 请求数据源 */
    dataSource: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};